import { useState, useCallback } from "react";

const SESSION_KEY_PREFIX = "table_page_";

export const useCachedPage = (tableKey: string, initialPage = 1): [number, (page: number) => void] => {
	const storageKey = SESSION_KEY_PREFIX + tableKey;

	const [page, setPageState] = useState<number>(() => {
		const cached = sessionStorage.getItem(storageKey);
		if (cached !== null) {
			const parsed = Number(cached);
			if (!Number.isNaN(parsed) && parsed >= 1) return parsed;
		}
		return initialPage;
	});

	const setPage = useCallback(
		(newPage: number) => {
			setPageState(newPage);
			sessionStorage.setItem(storageKey, String(newPage));
		},
		[storageKey]
	);

	return [page, setPage];
};
